import { Box, ColorOptions, Form, Loader, Spacer, Text } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { observer } from 'mobx-react'
import { useCallback, useEffect, useState } from 'react'
import { DefaultFormContainer } from '../../comps/DefaultFormContainer'
import { SvgImage } from '../../comps/SvgImage'
import { ToastType } from '../../comps/Toast'
import { useLazyApiData, useStores } from '../../data/store'
import { Routes } from '../../nav/routes'
import { getString } from '../../util/languageStrings'
import { Colors, isSessionValid, logEvent, useWindowDimensions } from '../../util/util'
import ShowHidePassword from '../Login/LoginCard/ShowHidePassword'
import { isActive } from './CheckList'
import { resetForm } from './FormDataForMobile'
import { styles } from './styles'

const delay = (ms) => new Promise(res => setTimeout(res, ms));

const handleLogin = async (
  resetState: string | undefined,
  loginState: string | undefined,
  resetStateData: any,
  mobileNum: string,
  password: string,
  handleInvalidOtp: () => void,
  handleNavigation: (s: string) => void,
  login: (usr: string, password: string) => void,
  isSignUp: boolean,
) => {
  if (resetState === 'fulfilled' && !loginState) {
    if (resetStateData && resetStateData?.status === 'SUCCESS') {
      if (isSignUp) {
        login(mobileNum, password)
      } else {
        handleNavigation('fulfilled')
      }
    } else {
      await delay(3000)
      handleInvalidOtp()
    }
  }
  if (loginState === 'fulfilled' || loginState === 'rejected') {
    handleNavigation(loginState)
  }
  if (resetState === 'rejected') {
    handleInvalidOtp()
  }
}

const ResetPwdMobile = ({ params }) => {
  const show = true
  const otp = params?.otp
  const isSignUp = params?.isSignUp

  const {
    forgotResetPassword,
    verifyCredentials,
    mobileNum,
    onboardMerchant,
    sessionData,
    isUserNotFoundInIdam,
    setPasswordForIdam,
    setMessage,
    setToastType,
    selectedAppLanguage,
  } = useStores((root) => ({
    forgotResetPassword: root.user.forgotResetPassword,
    verifyCredentials: root.user.session.verifyCredentials,
    mobileNum: root.settings.metaData.mobileNumber,
    onboardMerchant: root.user.onboardMerchant,
    sessionData: root.user.session,
    isUserNotFoundInIdam: root.settings.metaData.isUserNotFoundInIdam,
    setPasswordForIdam: root.user.setPasswordOnIDAM,
    setMessage: root.response.setMessage,
    setToastType: root.response.setToastType,
    selectedAppLanguage: root.settings.config.selectedAppLanguage,
  }))

  const [login, loginHandler] = useLazyApiData(verifyCredentials)
  const [resetPassword, resetHandler] = useLazyApiData(forgotResetPassword)
  const [signUpMerchant, signUpMerchantHandler] = useLazyApiData(onboardMerchant)
  const [setIdamPwd, idamPwdHandler] = useLazyApiData(setPasswordForIdam)

  const [password, setPassword] = useState('')
  const [isLoading, setLoadingState] = useState(false)
  const initData = { password: '', passwordConfirm: '' }

  const navigation = useNavigation()

  const handleInvalidOtp = (): any => {
    navigation.reset({
      index: 0,
      routes: [
        {
          name: Routes.FORGOT_PASSWORD,
          params: { path: Routes.FORGOT_PASSWORD },
        },
      ],
    })
  }
  const handleNavigation = useCallback(
    (status: string): any => {
      if (status === 'fulfilled') {
        if (isSignUp) {
          navigation.navigate(Routes.ADD_ACCNT)
        } else {
          setToastType(ToastType?.POSITIVE)
          setMessage(
            isUserNotFoundInIdam
              ? 'Password set successfully. Please login'
              : 'Password changed successfully. Please login',
          )
          navigation.reset({
            index: 0,
            routes: [
              {
                name: Routes.LOGIN,
              },
            ],
          })
        }
      } else {
        navigation.reset({
          index: 0,
          routes: [
            {
              name: Routes.LOGIN,
            },
          ],
        })
      }
    },
    [isSignUp, isUserNotFoundInIdam, navigation, setMessage],
  )

  const viewPortWidth = useWindowDimensions()

  useEffect(() => {
    handleLogin(
      resetHandler.state,
      loginHandler.state,
      resetHandler?.data,
      mobileNum,
      password,
      handleInvalidOtp,
      handleNavigation,
      login,
      isSignUp,
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [login, loginHandler.state, resetHandler.state])

  useEffect(() => {
    handleLogin(
      idamPwdHandler.state,
      loginHandler.state,
      idamPwdHandler?.data,
      mobileNum,
      password,
      handleInvalidOtp,
      handleNavigation,
      login,
      isSignUp,
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [login, loginHandler.state, idamPwdHandler.state])

  useEffect(() => {
    const navigateToLogin = () => {
      navigation.reset({
        index: 0,
        routes: [
          {
            name: Routes.LOGIN,
          },
        ],
      })
    }
    if (signUpMerchantHandler.state === 'fulfilled') {
      setLoadingState(false)
      isSessionValid(sessionData) ? handleNavigation('fulfilled') : navigateToLogin()
    } else if (signUpMerchantHandler.state === 'rejected') {
      setLoadingState(false)
    }
  }, [handleNavigation, navigation, sessionData, signUpMerchantHandler, signUpMerchantHandler.state])

  if (!show) {
    return null
  }
  // const isLoading = loginHandler.state === 'pending' || resetHandler.state === 'pending'

  const handleBack = () => {
    navigation?.goBack()
  }
  const [hidePassword, setHidePassword] = useState(false)

  const getFormData = (): any[] => {
    const initialFormData = [
      ...resetForm(
        <ShowHidePassword
          isDisabled={resetHandler.state === 'pending'}
          isPasswordVisible={setHidePassword}
          showPassword={hidePassword}
        />,
        hidePassword,
        selectedAppLanguage,
      ),
    ]
    return initialFormData
  }

  const renderActionButtons = ({ values, isCurrentFormValid, defaultActionButtonOnSubmit }: any) => {
    const passwordStrength = isActive(values?.password)?.length
    const disabled = !(isCurrentFormValid && passwordStrength === 8) || isLoading
    const handleResetPassword = () => {
      defaultActionButtonOnSubmit()
      if (!disabled) {
        setPassword(values.password)
        if (!isSignUp) {
          logEvent('btn_press', 'reset_password')
          setIdamPwd(mobileNum, values.password, otp)
          // if (!isUserNotFoundInIdam) {
          //   resetPassword(mobileNum, values.password, otp)
          // } else {
          //   setIdamPwd(mobileNum, values.password, otp)
          // }
        } else {
          setLoadingState(true)
          signUpMerchant(mobileNum, values.password, otp)
        }
      }
    }
    return (
      <Box
        {...styles(viewPortWidth).buttonContainer}
        bg={Colors.PRIMARY as ColorOptions}
        onPress={handleResetPassword}
        testID="contine"
        h={48}
        justify={'center'}
        borderRadius={24}
        underlayColor={Colors.PRIMARY as ColorOptions}>
        <Text hide={isLoading} color={'WHITE'} fontFamily={'JioType-Bold'} fontSize={16} letterSpacing={-0.08}>
          {getString(selectedAppLanguage, 'continue')}
        </Text>
        {isLoading && <Loader color={'WHITE'} />}
      </Box>
    )
  }

  return (
    <Box f={1} align={'center'} justify={'space-between'} bg={'SECONDARY'} flexDirection={'column'}>
      <Box w={'100%'} h={64} ph={16} align={'flex-start'} justify={'center'}>
        <Box onPress={handleBack} testID="arrow-back" underlayColor={'TRANSPARENT'}>
          <SvgImage imageName="HeaderArrowLeft" />
        </Box>
      </Box>

      <Box {...styles(viewPortWidth).cardContainer} mt={0} pt={0} f={1}>
        <Box
          {...styles(viewPortWidth).card}
          borderBottomLeftRadius={0}
          borderBottomRightRadius={0}
          borderTopLeftRadius={24}
          flexGrow={1}
          paddingHorizontal={24}
          mt={0}
          pt={35}
          width={'100%'}
          borderTopRightRadius={24}>
          <Text
            title={getString(selectedAppLanguage, 'resetPassword')}
            fontFamily={'JioType-Black'}
            fontSize={24}
            lineHeight={32}
            letterSpacing={-0.12}
          />
          <Spacer direction={'vertical'} size={40} />
          <Box {...styles(viewPortWidth).formContainer}>
            <Form
              container={DefaultFormContainer}
              formData={getFormData()}
              actionButtons={renderActionButtons}
              initialValues={initData}
            />
          </Box>
        </Box>
      </Box>

      {isLoading && (
        <Box
          bg={'BLACK'}
          opacity={0.5}
          position={'absolute'}
          top={0}
          bottom={0}
          left={0}
          right={0}
          justify={'center'}
          align={'center'}>
          <Loader type={'large'} />
        </Box>
      )}
    </Box>
  )
}

export default observer(ResetPwdMobile)
